import React, { useState } from 'react'

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  const closeMenu = () => {
    setMenuOpen(false)
  }

  return (
    <header className="header">
      <a className="logo" href="/">
        <div className="logo-img">
          <img src="images/logo.PNG" alt="Logo Agrosinal" />
        </div>
        <div>
          <div className="logo-name">AGROSINAL</div>
          <div className="logo-tagline">Tecnologia</div>
        </div>
      </a>

      <div className="nav-wrapper">
        <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <a href="#sobre" onClick={closeMenu}>
            Sobre
          </a>
          <a href="#servicos" onClick={closeMenu}>
            Serviços
          </a>
          <a href="#produtos" onClick={closeMenu}>
            Produtos
          </a>
        </nav>

        <a href="https://wa.me/5567981414278" className="nav-destaque">
          Fale Conosco
        </a>
        <button
          className={`hamburger ${menuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {menuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
    </header>
  )
}

export default Header
